module.exports = __webpack_public_path__ + "static/media/navidad2.5c4ce5b6.jpg";